import type { MessageEntity } from '@platform/timeline';
import { RUN_FAILURE_FALLBACK_MESSAGE } from '../../chat/runFailureMessage';
import { registerSem } from '../registry';

registerSem('run.failed', ({ ev, now, convId }) => {
  const data = (ev.data || {}) as {
    run_id?: string;
    error_category?: string;
    user_message?: string;
    error_code?: string;
  };

  const userMessage =
    typeof data.user_message === 'string' && data.user_message.trim().length > 0
      ? data.user_message.trim()
      : RUN_FAILURE_FALLBACK_MESSAGE;

  const entity: MessageEntity = {
    id: `run-failed-${ev.id || now}`,
    kind: 'message',
    timestamp: now,
    props: {
      role: 'system',
      content: userMessage,
      severity: 'error',
      metadata: {
        run_id: typeof data.run_id === 'string' ? data.run_id : undefined,
        error_category: typeof data.error_category === 'string' ? data.error_category : undefined,
        error_code: typeof data.error_code === 'string' ? data.error_code : undefined,
      },
    },
  };

  return { kind: 'add', convId, entity };
});
